<style>
  /* .filtri-container .card{
    background: #f9fafb !important;
  } */
  .p-drawer-right .p-drawer{
    width: 40vw !important;
  }
  .filtri-inline, .filtri-inline input{
     width: 100%;
   }
</style>

<template>
  <div class="filtri-container">
    <div class="card flex align-end" style="flex-direction: row; grid-column-gap: 20px; box-shadow: unset">
      <div class="refresh">
        <CustomButton style="height: 40px" @click="reloadData" icon="pi pi-refresh"  />
      </div>
      <div class="filtri-inline" v-if="isPM">
        <FloatLabel variant="on">
          <InputText  id="esecuotre_inline" @keyup="filtraInline" v-model="esecutoreInline" />
          <label for="esecuotre_inline">Esecutore</label>
        </FloatLabel>
      </div>
      <Drawer v-model:visible="show" header="Filtri" position="right" >
        <CustomForm v-slot="$form"  :initialValues="initialValues" :resolver="resolver" @submit="onFormSubmit" class="flex flex-col gap-4 w-full md:w-56" style="margin-top: 30px;">
          <div class="row">
            <div class="col-12">
              <div class="flex flex-col gap-1">
                <FloatLabel class="w-full md:w-56" variant="on">
                  <CustomSelect :virtualScrollerOptions="{ itemSize: 38 }" filter name="esecutore" :options="esecutori" showClear  optionLabel="user" optionValue="id_account" :loading="esecutori.length<=0"   />
                  <!--            <Message v-if="$form.city?.invalid" severity="error" size="small" variant="simple">{{ $form.city.error.message }}</Message>-->
                  <label for="over_label">Esecutore</label>
                </FloatLabel>
              </div>
            </div>
            <div class="col-12 mt-10">
              <div class="flex flex-col gap-1">
                <FloatLabel class="w-full md:w-56" variant="on">
                  <CustomSelect :virtualScrollerOptions="{ itemSize: 38 }" filter name="lavoro" :options="lavori" showClear  @change="lavoroSelected($form)" optionLabel="titolo" optionValue="id_ticket" :loading="lavori.length<=0"   />
                  <!--            <Message v-if="$form.city?.invalid" severity="error" size="small" variant="simple">{{ $form.city.error.message }}</Message>-->

                  <label for="over_label">Lavoro</label>
                </FloatLabel>
              </div>
            </div>
            <div class="col-12 mt-10">
              <div class="flex flex-col gap-1">
                <FloatLabel class="w-full md:w-56" variant="on">
                  <CustomSelect :virtualScrollerOptions="{ itemSize: 38 }" filter name="attivita" :options="attivita" showClear  optionLabel="titolo" optionValue="id_ticket"  :loading="attivita.length<=0"   />
                  <!--            <Message v-if="$form.city?.invalid" severity="error" size="small" variant="simple">{{ $form.city.error.message }}</Message>-->
                  <label for="over_label">Attività</label>
                </FloatLabel>
              </div>
            </div>
            <div class="col-12 mt-10">
              <CustomButton type="submit" severity="primary" label="Applica filtri"></CustomButton>
            </div>
          </div>
        </CustomForm>
      </Drawer>
      <CustomButton style="height: 40px" icon="pi pi-filter-fill" @click="showFilters" v-if="isPM" />
    </div>
  </div>
</template>



<script>
import CustomButton from 'primevue/button';
import Message from 'primevue/message';
import CustomTextArea from 'primevue/textarea';
import InputNumber from 'primevue/inputnumber';
import CustomSelect from 'primevue/select';
import { Form as CustomForm } from '@primevue/forms';
import FloatLabel from 'primevue/floatlabel';
import * as $ from 'jquery';
import { ref} from 'vue';
import { useSlots } from 'vue';
import Drawer from 'primevue/drawer';
import VirtualScroller from 'primevue/virtualscroller';
import InputText from 'primevue/inputtext';
export default {
  name: "KFiltriDashboard",
  components:{CustomForm, CustomSelect, FloatLabel,  CustomButton,Drawer, InputText},
  props:{
    isPM: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      esecutoreInline:'',
      userId:-1,
      status:'',
      lavori:[],
      attivita:[{
        cache_titolo:'',
        id_ticket:-1
      }],
      esecutori:[],
      show: false,
      initialValues:{}
    }
  },
  setup(){
    return{
      form:ref("$form")
    }
  },
  mounted(){

  },
  created() {
    $(document).keyup(function (e) {
      if (e.key === "Escape" && this.show) {
        this.annulla();
      }
    }.bind(this));

    this.$store.subscribe((mutation, state) => {
      if(mutation.type==='taskRicaricati'){
        if(this.isPM){
          this.$store.dispatch("loadLavori");
          this.$store.dispatch("loadAttivitaSenzaLavoro");
          this.$store.dispatch("loadTutteLeAttivita");
        }
      }
      // if (mutation.type === 'lavoriCaricati') {
      //   console.log("lavoriCaricati")
      //   this.lavori=[...mutation.payload];
      // }
      //
      // if(mutation.type==='attivitaLavoroCaricate'){
      //   this.attivita=[...mutation.payload];
      // }
      //
      // if(mutation.type==='attivitaSenzaLavoroCaricate'){
      //   this.attivita=[...mutation.payload];
      // }
      //
      // if (mutation.type === 'tasksCreated') {
      //   this.annulla()
      // }
    });

  },
  methods: {
    resolver: ({ values }) => {

      const errors = {};
      // if (!values.lavoro) {
      //   errors.lavoro = [{ message: 'Lavoro is required.' }];
      // }
      // if (!values.attivita) {
      //   errors.attivita = [{ message: 'Attività is required.' }];
      // }
      // if (!values.DOD) {
      //   errors.DOD = [{ message: 'Inserire una DOD.' }];
      // }

      return {
        errors
      };
    },
    onFormSubmit({values, states, valid, errors}) {
      if(valid){
        let filtri={
          idEsecutore:states.esecutore.value,
          idLavoro:states.lavoro.value,
          idAttivita:states.attivita.value
        }
        if(!filtri.idEsecutore)
          filtri.idEsecutore=-1
        if(!filtri.idLavoro)
          filtri.idLavoro=-1
        if(!filtri.idAttivita)
          filtri.idAttivita=-1
        this.$store.dispatch('applicaFiltriClient',{...filtri});
        this.show=false;
      }
    },
    showFilters(){
      this.show=true;
      this.lavori=[...this.$store.getters.getLavori()];

      this.attivita=[...this.$store.getters.getAttivitaTutte()];

      this.esecutori=[...this.$store.getters.getEsecutori()];

      let filtriApplicati=this.$store.getters.getFiltriApplicati();

      if(filtriApplicati.idLavoro && filtriApplicati.idLavoro!==-1){
        this.attivita=[...this.$store.getters.getAttivitaLavoro(filtriApplicati.idLavoro)];
      }
      this.initialValues={
        esecutore:(filtriApplicati.idEsecutore&&filtriApplicati.idEsecutore!==-1)?filtriApplicati.idEsecutore:undefined,
        lavoro:(filtriApplicati.idLavoro && filtriApplicati.idLavoro!==-1)?filtriApplicati.idLavoro:undefined,
        attivita:(filtriApplicati.idAttivita&&filtriApplicati.idAttivita!==-1)?filtriApplicati.idAttivita:undefined,
      }
    },
    annulla(){
      this.show=false;
      this.userId=-1;
      this.status="";
    },
    lavoroSelected(form){
      this.attivita=[];
      form.attivita.value=undefined;
      if(form?.lavoro?.value){

        this.attivita=[...this.$store.getters.getAttivitaLavoro(form?.lavoro?.value)];
        // this.$store.dispatch('loadAttivitaLavoro', {
        //   idTicket:form?.lavoro?.value
        // });
      }else{
        this.attivita=[...this.$store.getters.getAttivitaTutte()];
      }
    },
    filtraInline(){
      if(this.esecutoreInline.length>=3||this.esecutoreInline.length===0)
      this.$store.dispatch('filtraEsecutoriInline',{
        esecutore:this.esecutoreInline
      });
    },
    reloadData(){
      let lastFetch=this.$store.getters.getLastFetch();

      this.$store.dispatch('refreshTasks',{
        lastFetch:lastFetch,
        isPM:this.isPM
      });
      if(this.isPM){
        this.$store.dispatch("loadNotifiche");
      }
    }
  }
}
</script>